import React, { useEffect } from "react";
import { Container } from "semantic-ui-react";
import IntroSection from "./IntroSection";
import OtherPatterns from "./OtherPatterns";
import Comments from "../../components/Comments";
import { connect } from "react-redux";
import { getCurrentProfile } from "../../actions/profileActions";
import { useParams } from "react-router-dom";
import { ProfileData } from "../../types/siteTypes";
import { profileSelector } from "../../utils/selectors";

type Props = {
  profile: { profile: ProfileData };
  getProfile: () => void;
};

const PatternPage: React.FC<Props> = ({
  profile: { profile },
  getProfile,
}) => {
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    getProfile();
    window.scrollTo(0, 0);
  }, [getProfile]);
  return (
    <div>
      <IntroSection patternId={id || ''} />
      <Container>
        <OtherPatterns patternId={id || ''} />
        <Comments />
      </Container>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  profile: profileSelector(state),
});
const mapDispatchToProps = (dispatch: any) => ({
  getProfile: () => dispatch(getCurrentProfile()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatternPage);
